import React from 'react';
import { Container, Typography, TextField, Button, Box } from '@mui/material';

export default function Contact() {
  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom textAlign="center">Contact Us</Typography>
      <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 3 }}>
        <TextField label="Your Name" fullWidth required />
        <TextField label="Your Email" type="email" fullWidth required />
        <TextField label="Message" multiline rows={4} fullWidth required />
        <Button variant="contained" size="large" sx={{ bgcolor: '#1e293b' }}>Send Message</Button>
      </Box>
    </Container>
  );
}